$(function () {

    var flexCarousel = $('.flex_carousel');

    if (flexCarousel.length < 1) {
        return;
    }

    $('.flex_carousel__slide_wrap').removeClass('flex_carousel__slide_wrap--no-js');
    $('.flex_carousel__control_wrap').removeClass('flex_carousel__control_wrap--hidden');

    var flexCarouselSlider = tns({
        container: '.flex_carousel__slide_wrap',
        items: 1,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 7000,
        speed: 1000,
        loop: true,
        nav: true,
        navPosition: 'bottom',
        navContainer: '.flex_carousel__control_wrap .carousel_pager_wrap',
        mouseDrag: false,
        arrowKeys: false,
        touch: true,
        controls: true,
        nextButton: '.flex_carousel__control_wrap .control--next',
        prevButton: '.flex_carousel__control_wrap .control--previous',
        preventActionWhenRunning: true,
    });

    $('.pager').on('click', function (e) {
        e.preventDefault();
    });

});